<template>
	<div>
		<div class="navbar">
			<div class="container" v-if="!onlyClientLogin">
				<div class="nav-left" :class="centerLogo">
					<div v-if="onlyLogo">
						<img class="logo-nav" src="@/assets/img/logo-guard.png" />
					</div>
					<router-link to="/" v-on:click.native="resetAnalyze" v-if="!onlyLogo">
						<img class="logo-nav" src="@/assets/img/logo-guard.png" />
						<img class="d-none d-lg-inline-block logo-label" src="@/assets/img/logo-guard-text.png"/>
					</router-link>
				</div>
				<div class="nav-right d-none d-sm-block" v-if="!onlyLogo">
					<a :class="selected" @focus="isSolutions = false" v-on:click="solutionClick" v-on-clickaway="awayClick">
						<div v-if="isSolutions" class="solutions">
							<div class="description">
								<h3>Get Started</h3>
								<p>Cosmic Guard’s DDoS Mitigation platform is built to protect from the digital threats of tomorrow to secure your online assets.</p>
							</div>
							<div class="links">
								<router-link to="/gaming" class="link-gaming"><span>Gaming</span></router-link>
								<router-link to="/servers" class="link-servers"><span>Servers</span></router-link>
								<router-link to="/hosts" class="link-hosts"><span>Hosts</span></router-link>
								<router-link to="/enterprise" class="link-enterprise"><span>Enterprise</span></router-link>
							</div>
						</div>
						Solutions
					</a>
					<span class="login">
						<a href="/portal/">Login</a>
					</span>
					<span class="under-attack">
						<router-link to="/signup">Sign Up</router-link>
					</span>
				</div>
				<div class="nav-right-burger d-sm-none d-block">
					<span class="float-right menu" v-on:click="burgerClick">Menu</span>
					<div v-if="isBurger" class="burger-screen">
						<div class="menu-corner">
							<img class="logo-nav logo-burger" src="@/assets/img/logo-guard.png" />
							<span class="float-right menu" v-on:click="burgerClick">Menu</span>
						</div>
						<div class="menu-options">
							<span class="option solution-burger" v-on:click="burgerSolutionsClick">
								Solutions
							</span>
							<div class="solutions-options" v-if="isBurgerSolutions">
								<router-link to="/gaming" class="link-gaming"><span>Gaming</span></router-link>
								<router-link to="/servers" class="link-servers"><span>Servers</span></router-link>
								<router-link to="/hosts" class="link-hosts"><span>Hosts</span></router-link>
								<router-link to="/enterprise" class="link-enterprise"><span>Enterprise</span></router-link>
							</div>
							<span class="option login-burger">
								<a href="/portal/">Login</a>
							</span>
							<span class="option attack-burger">
								<router-link to="/signup">Sign Up</router-link>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="container" v-if="onlyClientLogin">
				<div class="nav-right">
					<a href="/portal/">Client Login</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
	name: "Navbar",
	mixins: [ clickaway ],
	props: {
		onlyClientLogin: {
			type: Boolean,
			default: false
		},
		onlyLogo: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isSolutions: false,
			isBurger: false,
			isBurgerSolutions: false
		}
	},
	methods: {
		solutionClick: function() {
			this.isSolutions = !this.isSolutions;
		},
		awayClick: function() {
			this.isSolutions = false;
		},
		burgerClick: function() {
			this.isBurger = !this.isBurger;
		},
		burgerSolutionsClick: function() {
			this.isBurgerSolutions = !this.isBurgerSolutions;
		},
		centerLogo: function() {
			return {
				logoCenter: this.onlyLogo
			}
		},
		resetAnalyze: function() {
			this.$emit('reset-analyze', false);
		}
	},
	computed: {
		selected: function() {
			let vm = this;
			return {
				'selected': vm.isSolutions
			}
		},
		burgerSelected: function() {
			let vm = this;
			return {
				'burger-selected': vm.isBurger
			}
		}
	}
};
</script>

<style scoped>
.navbar {
	background-color: #141d28;
	overflow: hidden;
}
.logoCenter {
	margin: auto;
}

.navbar .container {
    display: flex;
    overflow: hidden;
	background-color: #141d28;
	padding: 0px;
}

.nav-right a, .navbar img {
    float: left;
    display: block;
    padding: 6px 10px;
    text-decoration: none;
    margin: auto;
    margin-left: 8px;
}

.logo-nav {
	display: inline-block !important;
	float: none !important;
	height: 60px;
	min-width: 3.8em;
}
.logo-label {
	padding-left: 0 !important;
	margin-left: 0 !important;
	float: none !important;
	width: 16em;
	max-height: 4em;
}

.nav-left, .nav-right {
    line-height: 3em;
}

@media only screen and (max-width: 410px) {
    .nav-left, .nav-right {
        margin: 0em 0 0 1em;
    }
	.nav-right a{
		margin-left: auto;
	}
}

.nav-right {
	margin-left: auto;
    color: #3a70c7;
    text-transform: uppercase;
    font-weight: 600;
}

.login, .login * {
	font-size: 16px;
	font-weight: 600;
	color: white;
	padding: 0px 0.5em !important;
}
.login > a {
	margin: 0.7em 0 0 1em;
	border: 2px solid rgb(58, 112, 199);
	border-radius: 0.3em;
	line-height: 2em;
    transition: border-color .1s ease, background-color .1s ease;
}
.under-attack, .under-attack * {
	font-size: 16px;
	font-weight: 600;
	color: white;
	padding: 0px 0.5em !important;
}
.under-attack > a {
	margin: 0.7em 0 0 1em;
	border: 2px solid rgb(187, 31, 31);
	border-radius: 0.3em;
	line-height: 2em;
    transition: border-color .1s ease, background-color .1s ease;
}

.nav-right > a {
	margin: 0;
	box-shadow: inset 0px -3px 0px 0px rgba(255, 255, 255, 0);
	transition: 0.2s box-shadow;
}

.nav-right > a:hover {
	box-shadow: inset 0px -3px 0px 0px aliceblue;
}

.selected {
	color: aliceblue !important;
	box-shadow: inset 0px -3px 0px 0px aliceblue !important;
}

.nav-right-burger {
	margin-left: auto;
}
.menu {
	cursor: pointer;
	float: right;
	padding: 5px 12px 4px;
	margin: 0.5em;
	margin-right: 1em;
    border: 1px solid rgba(255,255,255,.5);
    border-radius: 5px;
    transition: border-color .1s ease, background-color .1s ease;
}
.menu:hover {
	text-decoration: none;
    border-color: #fff;
	background-color: rgba(255,255,255,.15);
}
.burger-selected {
	text-decoration: none;
    border-color: #fff;
	background-color: rgba(255,255,255,.15);
}
.burger-screen {
	position: fixed;
	width: 100vw;
	top: 0;
	left: 0;
	background-color: #141d28;
	z-index: 100;
}
.logo-burger {
	margin-left: 1em !important;
}
.menu-options {
	max-width: 60%;
	width: 75%;
	margin: auto;
	text-transform: uppercase;
}
.menu-options span {
	display: block;
	margin: 0.4em 0;
	padding: 0.3em 0;
	font-weight: 600;
}
.attack-burger {
	color: white !important;
	border: 2px solid rgb(187, 31, 31);
	border-radius: 0.3em;
    transition: border-color .1s ease, background-color .1s ease;
}
.login-burger {
	color: white !important;
	border: 2px solid rgb(58, 112, 199);
	border-radius: 0.3em;
    transition: border-color .1s ease, background-color .1s ease;
}
.login-burger:hover, .login:hover a {
	border-color: rgb(13, 106, 255);
	background-color: rgba(58, 112, 199, 0.15);
}
.attack-burger:hover, .under-attack:hover a {
	border-color: rgb(255, 13, 13);
	background-color: rgba(255, 0, 0, 0.15);
}
.option {
	text-align: center;
	padding: 0.5em;
}
.solution-burger {
	box-shadow: inset 0px -3px 0px 0px rgba(240, 248, 255, 0.3);
	transition: box-shadow .2s ease;
}
.solution-burger:hover {
	box-shadow: inset 0px -3px 0px 0px aliceblue;
}
.option:hover {
	cursor: pointer;
}
.solutions-options {
	font-weight: 600;
	font-size: 1.2em;
	text-align: center;
	color: rgb(58, 112, 199);
}

a:hover {
	cursor: pointer;
}
.solutions {
	margin-top: 54px;
	/*padding: 1em 2em;*/
	/*padding: 0 2em;*/
	padding: 0;
	position: absolute;
	right: 0;
	background-color: #1c2937;
	z-index: 100;
	color: #427ed6 !important;
	display: flex;
	border-radius: 0.3em;
}
@media only screen and (min-width: 900px) {
    .solutions {
		right: auto;
		margin-left: -21em;
	}
}
@media only screen and (max-width: 768px) {
    .solutions {
		display: block;
		padding: 1em;
		right: auto;
		margin-left: -2em;
		padding-top: 2em;
		padding-bottom: 2em;
	}

	.solutions .description {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}

	.solutions .links {
		padding-top: 0 !important;
	}
	
	.solutions .description > p {
		border: none !important;
	}
}
.solutions > .description, .solutions > .links {
	width: 18em;
}
.solutions .description {
	color: white !important;
	line-height: 1.5em;
	padding: 2em;
	margin-right: 0;
}
.solutions .description > h1 {
	margin-bottom: 0;
}
.solutions .description > p {
	margin-bottom: 0;
    width: 16em;
    margin-top: 0;
    padding-top: 1em;
    padding-right: 2em;
    border-right: 1px solid rgb(91, 102, 128);
    padding-bottom: 1em;
    font-weight: 400;
}
.links {
	margin-top: auto;
	padding: 2em;
}
.links >  a{
	font-size: 10px;
	line-height: 2.5em;
}
.links > a > span {
	font-weight: 600;
	font-size: 18px;
}
.solutions > .links > a {
	width: 100%;
	margin: 0 !important;
	text-align: left;
	display: block;
	color: #fff;
	margin-top: 0.4em !important;
	box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);
}
.solutions-options a, .solutions > .links > a {
	display: block;
	color: #fff;
	border-radius: 5px;
	background-repeat: no-repeat;
	background-size: cover;
	transition: 0.5s box-shadow;
	background-position: center center;
}
.solutions-options a {
	background: none !important;
}
.solutions-options a:hover, .solutions > .links > a:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);
}
.solutions-options a:hover {
	text-decoration: none;
}
/*.link-gaming {
	background-image: url('~@/assets/img/button-back-game.png');
}
.link-servers {
	background-image: url('~@/assets/img/button-back-servers.png');
}
.link-hosts {
	background-image: url('~@/assets/img/button-back-hosts.png');
}
.link-enterprise {
	background-image: url('~@/assets/img/button-back-enterprises.png');
}*/
/*
.solutions > .links > *:not(:last-child)::after {
	content: "";
	border-bottom: solid 1px rgb(91, 102, 128);
	width: 100%;
	margin: auto;
	display: block;
}
*/
.solutions > .links > a:hover, .nav-right > a:hover {
	color: aliceblue;
}
.solutions-icons {
	padding: 5px !important;
	margin: 0px 5px 0 0 !important;
	width: 2.5em;
	vertical-align: 0;
}
</style>
